// === HELPERS FICHIERS (DOM) ===
// Téléchargement et lecture de fichiers depuis le navigateur. Isolé du
// reste pour pouvoir mocker facilement et garder la logique métier
// (SaveExport) purement testable.

/**
 * Déclenche le téléchargement d'un texte sous un nom donné. Crée un
 * `<a download>` invisible, click, puis nettoie le blob URL.
 */
export function downloadTextFile(filename: string, content: string, mimeType = 'application/json'): void {
  try {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    // Nettoyage différé pour laisser le download partir sur Firefox
    setTimeout(() => {
      try { document.body.removeChild(a); } catch { /* */ }
      try { URL.revokeObjectURL(url); } catch { /* */ }
    }, 100);
  } catch (e) {
    console.warn('[FileIO] Échec téléchargement:', e);
  }
}

/**
 * Ouvre un picker de fichier et retourne le contenu texte choisi.
 * Résout avec null si l'utilisateur annule.
 */
export function pickTextFile(accept = 'application/json,.json'): Promise<string | null> {
  return new Promise((resolve) => {
    try {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = accept;
      input.style.display = 'none';

      let settled = false;
      const cleanup = () => {
        try { document.body.removeChild(input); } catch { /* */ }
      };

      input.addEventListener('change', () => {
        if (settled) return;
        settled = true;
        const file = input.files?.[0];
        if (!file) { cleanup(); resolve(null); return; }
        const reader = new FileReader();
        reader.onload = () => {
          cleanup();
          resolve(typeof reader.result === 'string' ? reader.result : null);
        };
        reader.onerror = () => { cleanup(); resolve(null); };
        reader.readAsText(file);
      });

      // Fallback si l'utilisateur annule : on attend un focus retour sur la
      // fenêtre puis on résout null si rien n'a été sélectionné. Pas 100%
      // fiable mais évite les promesses pendantes éternellement.
      const onFocus = () => {
        setTimeout(() => {
          if (!settled) {
            settled = true;
            cleanup();
            window.removeEventListener('focus', onFocus);
            resolve(null);
          }
        }, 500);
      };
      window.addEventListener('focus', onFocus, { once: true });

      document.body.appendChild(input);
      input.click();
    } catch (e) {
      console.warn('[FileIO] Échec ouverture picker:', e);
      resolve(null);
    }
  });
}
